// Auth gate —— 包装受保护路由（如 /rooms）
// 未登录 → 跳 / (Login)；loading → 显示骨架

import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../lib/use-auth";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div className="auth-loading">
        <p className="muted">校验登录态…</p>
      </div>
    );
  }
  if (status === "anonymous") return <Navigate to="/" replace />;
  return <>{children}</>;
}
